module.exports = __webpack_public_path__ + "static/media/markerActive.077b2525.svg";